import { useApolloClient } from "@vue/apollo-composable";

export const useApollo = () => {
  const apollo = useApolloClient();
  return apollo.resolveClient();
};
